// extracted by mini-css-extract-plugin
module.exports = {"drugs-carousel":"DrugsCarousel_drugs-carousel__1IL7F","drug":"DrugsCarousel_drug__2YvLr"};